import { apiFetch } from "./apiFetch";
import { UserAdminInfo } from "./users";

export type GroupUserRole = "admin" | "owner" | "member";

export interface GroupAdminInfo {
  id: string;
  name: string;
  description: string;
  tag: string;
  logoUrl?: string;
  members: UserAdminInfo[];
}

export interface CreateGroupRequest {
  name: string;
  description: string;
  hashtag: string;
  logoUrl?: string;
}

export const GroupResource = {
  getList: () => apiFetch<GroupAdminInfo[]>("/admin/groups"),

  getById: (groupId: string) =>
    apiFetch<GroupAdminInfo>(`/admin/group/${groupId}`),

  create: (data: CreateGroupRequest) =>
    apiFetch<GroupAdminInfo>("/admin/group", { method: "POST", body: data }),

  delete: (groupId: string) =>
    apiFetch<void>(`/admin/group/${groupId}`, { method: "DELETE" }),

  getStatus: (groupId: string, dateStartUtc: string, dateEndUtc: string) =>
    apiFetch<Record<string, unknown>>(`/admin/group/${groupId}/status`, {
      searchParams: { dateStartUtc, dateEndUtc },
    }),

  addMember: (groupId: string, userId: string, role: GroupUserRole) =>
    apiFetch<GroupAdminInfo>(`/admin/group/${groupId}/user/${userId}`, {
      method: "POST",
      body: { role },
    }),

  removeMember: (groupId: string, userId: string) =>
    apiFetch<GroupAdminInfo>(`/admin/group/${groupId}/user/${userId}`, {
      method: "DELETE",
    }),
};
